import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsList from '@src/pc/index/layout/NewsList';
import MediaNews from '@src/pc/index/layout/MediaNews';
import Banner from '@src/pc/index/layout/components/Banner';
import Double from '@src/pc/index/layout/Double';
import TabControl from '@src/pc/index/layout/TabControl';
import LongImages from '@src/pc/index/layout/LongImages';
import ImageSwiper from '@src/pc/index/layout/ImageSwiper';
import News from '@src/pc/index/layout/News';
import Support from '@src/pc/index/layout/Support';
import Footer from '@src/pc/index/layout/Footer';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import { ChipMap } from '../chipMap';
import LargeVideo from '@src/pc/index/layout/LargeVideo';

const Layout = ({ content }) => {

    const GetContent = (id) => {
        switch (id) {
            case 'box1': {
                return (
                    <div className={styles.box1} key="box1" id="box1">
                        <Chip key="NewsList" {...ChipMap.NewsList} content={content.NewsList}>
                            <NewsList />
                        </Chip>
                        <MediaNews content={content} />
                    </div>
                );
            }
            case 'box2': {
                return (
                    <div className={styles.box2} key="box2" id="box2">
                        <Chip key="Banner3" {...ChipMap.Banner3}>
                            <Banner type="car" title={content.Banner3} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="LargeVideo" {...ChipMap.LargeVideo} content={content.LargeVideo}>
                            <LargeVideo />
                        </Chip>
                    </div>
                );
            }
            case 'box3': {
                return (
                    <div className={styles.box3} key="box3" id="box3">
                        <Chip key="Banner4" {...ChipMap.Banner4}>
                            <Banner type="large" title={content.Banner4} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="FenghuangGuanCha" {...ChipMap.FenghuangGuanCha} content={content.FenghuangGuanCha}>
                            <Double />
                        </Chip>
                    </div>
                );
            }
            case 'box4': {
                return (
                    <div className={styles.box4} key="box4" id="box4">
                        <Chip key="Banner5" {...ChipMap.Banner5}>
                            <Banner type="large" title={content.Banner5} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="DuDongZhongGuo" {...ChipMap.DuDongZhongGuo} content={content.DuDongZhongGuo}>
                            <Double />
                        </Chip>
                    </div>
                );
            }
            case 'box5': {
                return (
                    <div className={styles.box5} key="box5" id="box5">
                        <Chip key="Banner6" {...ChipMap.Banner6}>
                            <Banner type="large" title={content.Banner6} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="LiangHuiShaLong" {...ChipMap.LiangHuiShaLong} content={content.LiangHuiShaLong}>
                            <TabControl />
                        </Chip>
                    </div>
                );
            }
            case 'box6': {
                return (
                    <div className={styles.box6} key="box6" id="box6">
                        <Chip key="Banner7" {...ChipMap.Banner7}>
                            <Banner type="large" title={content.Banner7} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="TuPianCeHua" {...ChipMap.TuPianCeHua} content={content.TuPianCeHua}>
                            <LongImages />
                        </Chip>
                    </div>
                );
            }
            case 'box7': {
                return (
                    <div className={styles.box7} key="box7" id="box7">
                        <Chip key="Banner8" {...ChipMap.Banner8}>
                            <Banner type="large" title={content.Banner8} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <Chip key="GaoQindDaTu" {...ChipMap.GaoQingDaTu} content={content.GaoQingDaTu}>
                            <ImageSwiper />
                        </Chip>
                    </div>
                );
            }
            case 'box8': {
                return (
                    <div className={styles.box8} key="box8" id="box8">
                        <Chip key="Banner9" {...ChipMap.Banner9}>
                            <Banner type="large" title={content.Banner9} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <div className={styles.flex}>
                            <div className={styles.leftPart}>
                                <Chip key="Banner10" {...ChipMap.Banner10}>
                                    <div className={styles.newsTitle}>{content.Banner10}</div>
                                </Chip>
                                <Chip key="JiaBinGuanDian" {...ChipMap.JiaBinGuanDian} content={content.JiaBinGuanDian}>
                                    <News />
                                </Chip>
                                <Chip key="Banner11" {...ChipMap.Banner11}>
                                    <div className={styles.newsTitle}>{content.Banner11}</div>
                                </Chip>
                                <Chip key="XiangGuanBaoDao" {...ChipMap.XiangGuanBaoDao} content={content.XiangGuanBaoDao}>
                                    <News />
                                </Chip>
                            </div>
                            <Chip key="Support" {...ChipMap.Support} content={content.Support}>
                                <Support />
                            </Chip>
                        </div>
                    </div>
                );
            }
            case 'box9': {
                return (
                    <div className={styles.box9} key="box9" id="box9">
                        <Chip key="Banner12" {...ChipMap.Banner12}>
                            <Banner type="large" title={content.Banner12} style={{ margin: '30px 0 10px' }} />
                        </Chip>
                        <iframe src="https://news.ifeng.com/loc/lianghuiVote" scrolling="no" className={styles.iframe} />
                    </div>
                );
            }
        }
    };

    return (
        <div className={styles.layout}>
            <Chip key="Layout" {...ChipMap.Layout} content={content['Layout']}>
                <div />
            </Chip>
            <div className={styles.mainImage}>
                <Chip key="mainImage" {...ChipMap.mainImage}>
                    <img className={styles.banner} src={content.mainImage} alt="主图" />
                </Chip>
            </div>
            <div className={styles.main}>
                {
                    content.Layout.map((item) => {
                        return item.isShow ? GetContent(item.id) : null;
                    })
                }
            </div>
            <Footer />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
